import * as S from "./style";
import axiosInstance from "services/axiosInstance";
import { useEffect, useState } from "react";
// components
import LayoutDetails from "../../../../components/LayoutModal/LayoutDetails";
import Loading from "../../../../components/Loading";
// hooks
import useLoading from "../../../../hooks/useLoading";
// utils
import FormatarData from "utils/FormatData";

interface IDetails {
  isOpenModalUser: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

interface IData {
  id: number;
  first_name: string;
  last_name: string;
  is_admin: number;
  is_manager: number;
  discount: string;
  email: string;

  created_at: string;
  updated_at: string;
}

export default function Details({
  isOpenModalUser,
  setModalClose,
  selectedUrlId,
}: IDetails) {
  const [data, setData] = useState<IData | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const response = await axiosInstance.get(`user/${selectedUrlId}`);
        setData(response.data);
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  if (isOpenModalUser) {
    return (
      <LayoutDetails
        title="Detalhes do Usuário"
        subTitle="Veja todos os detalhes disponíveis sobre o Usuário."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentInfor>
                <S.Infor>
                  <p>Nome:</p>
                  <span>{`${data.first_name} ${data.last_name}` || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Tipo:</p>
                  <span>
                    {data.is_admin === 1 ? (
                      <p>Administrador</p>
                    ) : (
                      <p>Atendente</p>
                    )}
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>E-mail:</p>
                  <span>{data.email || "-"}</span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.FeaturedSection>
                <S.InforBody>
                  <p>Desconto</p>
                  <S.Description>{data.discount || "-"}%</S.Description>
                </S.InforBody>
                </S.FeaturedSection>
                
                <S.InforBody>
                  <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                  <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                </S.InforBody>
            </S.Body>
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
